import React, { Component } from 'react';
import { arrayOf, func, number, object, string } from 'prop-types';
import classNames from 'classnames';

import { injectIntl, intlShape } from '../../../util/reactIntl';

import FilterPopup from '../FilterPopup/FilterPopup';
import NumberRangeFilterForm from '../NumberRangeFilterForm/NumberRangeFilterForm';

import css from './NumberRangeFilterPopup.module.css';

class NumberRangeFilterPopupComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.toggleIsOpen = this.toggleIsOpen.bind(this);
  }

  handleSubmit(values) {
    const { onSubmit, urlQueryParams } = this.props;

    this.setState({ isOpen: false });
    onSubmit({
      ...urlQueryParams,
      minValue: values.minValue,
      maxValue: values.maxValue,
    });
  }

  handleClear() {
    const { onSubmit, urlQueryParams } = this.props;

    this.setState({ isOpen: false });
    onSubmit({
      ...urlQueryParams,
      minValue: null,
      maxValue: null,
    });
  }

  handleCancel() {
    const { onSubmit, initialValues } = this.props;

    this.setState({ isOpen: false });
    onSubmit(initialValues);
  }

  toggleIsOpen() {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  }

  render() {
    const {
      rootClassName,
      className,
      id,
      label,
      queryParamNames,
      initialValues,
      min,
      max,
      step,
      intl,
      ...rest
    } = this.props;
    const { minValue, maxValue } = initialValues || {};

    const hasValue = value => value != null;
    const hasInitialValues = initialValues && hasValue(minValue) && hasValue(maxValue);

    const labelForPlain = hasInitialValues
      ? intl.formatMessage(
          { id: 'NumberRangeFilterPopup.labelSelectedPlain' },
          {
            minValue,
            maxValue,
          }
        )
      : label;

    const labelForPopup = hasInitialValues
      ? intl.formatMessage(
          { id: 'NumberRangeFilterPopup.labelSelectedPopup' },
          {
            minValue,
            maxValue,
          }
        )
      : label;

    const classes = classNames(rootClassName || css.root, className);

    return (
      <FilterPopup
        className={classes}
        rootClassName={rootClassName}
        popupClassName={css.popupSize}
        label={labelForPlain}
        isSelected={hasInitialValues}
        id={`${id}.popup`}
        showAsPopup
        labelMaxWidth={250}
        onToggleActive={this.toggleIsOpen}
        isOpen={this.state.isOpen}
        contentPlaceholderText={labelForPopup}
        {...rest}
      >
        <NumberRangeFilterForm
          id={id}
          initialValues={initialValues}
          onClear={this.handleClear}
          onCancel={this.handleCancel}
          onSubmit={this.handleSubmit}
          intl={intl}
          contentRef={node => {
            this.filterContent = node;
          }}
          min={min}
          max={max}
          step={step}
          showAsPopup
          isOpen={this.state.isOpen}
        />
      </FilterPopup>
    );
  }
}

NumberRangeFilterPopupComponent.defaultProps = {
  rootClassName: null,
  className: null,
  initialValues: null,
  step: 1,
};

NumberRangeFilterPopupComponent.propTypes = {
  rootClassName: string,
  className: string,
  id: string.isRequired,
  label: string.isRequired,
  queryParamNames: arrayOf(string).isRequired,
  onSubmit: func.isRequired,
  initialValues: object,
  min: number.isRequired,
  max: number.isRequired,
  step: number,

  // form injectIntl
  intl: intlShape.isRequired,
};

const NumberRangeFilterPopup = injectIntl(NumberRangeFilterPopupComponent);

export default NumberRangeFilterPopup;
